<template>
    <div id="subOutputRank-print">
        <el-row>
          <el-col :span="24">
            <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000">销售单审核（转采购）- 订单详情</h1>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <table style="width: 100%">
              <thead>
                <tr>
                  <th width="50">序号</th>
                  <th width="160">产品编码</th>
                  <th >产品名称</th>
                  <th width="50">单位</th>
                  <th width="60">数量</th>
                  <th >配送供应商名称</th>
                  <th width="60">采购价</th>
                </tr>
              </thead>
              <!-- <tfoot>
              </tfoot> -->
              <tbody>
                <tr v-for="(item, index) in tableData" :key="index">
                  <td>{{ index+1 }}</td>
                  <td>{{ item.PRODUCT_CODE }}</td>
                  <td>{{ item.PRODUCT_NAME }}</td>
                  <td>{{ item.TYPE_UNIT }}</td>
                  <td>{{ item.PRODUCT_COUNT }}</td>
                  <td>{{ item.RELATED_SUPPLIER_NAME }}</td>
                  <td>{{ item.SUPPLIER_REAL_PRICE }}</td>
                </tr>
              </tbody>
            </table>
            <!-- <div id="footer">
            </div> -->
          </el-col>
        </el-row>
      </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
  },
};
</script>

<style scoped>
ul {
    margin-top: 0;
    padding-top: 0;
    padding-left: 0;
  }

  li {
    list-style: none;
    font-size: 20px;
    line-height: 30px;
    color: #000;
    font-family: 黑体;
  }

  span {
    font-size: 20px;
    line-height: 35px;
    color: #000;
    font-family: 黑体;
  }
  h1{
    counter-reset: page;
  }
  table {
    border-collapse: collapse;
    width: 130%;
    border: 1px solid #000;
    font-weight: bold;
    table-layout: fixed;
  }
  table::before{
    height: 0 !important;
  }
  td,
  th {
    border: 1px solid #000;
    text-align: center;
    font-weight: normal;
    font-size: 20px;
    height: 24px;
    font-family: 黑体;
    color: #000;
    word-break: break-all;
    word-wrap:break-word;
  }
  tr {
    page-break-inside: avoid;
  }
  #footer{
    position: fixed;
    bottom: 0;
    right: 0;
  }
  tfoot{
    display: table-footer-group;
    height: 20px;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/sendDocument/printDetail.vue